<template>
  <div class="container-fluid">
    <OnboardingPopover
      position="top"
      :is-visible="showOnboardingPopover"
      :title="$label(`${onboardingLabel}.title`)"
      :text="$label(`${onboardingLabel}.content`)"
      :extra-items="[
        {
          text: $label(`${onboardingLabel}.infoText`),
          href: $label(`${onboardingLabel}.infoHref`)
        }
      ]"
      :on-next="onboardingOnNext"
    >
      <div
        :class="[
          'row choose-book-alert text-center d-flex justify-content-center',
          { 'choose-book-alert--highlighted': showOnboardingPopover }
        ]"
      >
        <div md="6" class="col col-md-6">
          <h2 class="mb-16">
            {{ $label('subscription.basic.chooseBookAlert.title') }}
          </h2>
          <p class="mb-24">
            {{ $label('subscription.basic.chooseBookAlert.text') }}
          </p>
          <BaseButton
            data-testid="choose-book-btn"
            variant="call-to-action"
            @click="openModal"
          >
            {{ $label('subscription.basic.chooseBookAlert.button') }}
          </BaseButton>
        </div>
      </div>
    </OnboardingPopover>

    <ConfirmBookModal :book="book" :hide-modal="modal.hide" />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useOnboardingStore } from '~/stores/onboarding'
import ConfirmBookModal from '~/components/basicSubscription/ConfirmBookModal'
import OnboardingPopover from '~/components/onboarding/OnboardingPopover'
import { ONBOARDING_VARIANTS } from '~/utils/constants'
import { useModal } from '~/composables/useModal'

export default {
  components: {
    ConfirmBookModal,
    OnboardingPopover
  },
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  setup() {
    const modal = useModal('confirmBook')

    return { modal }
  },
  computed: {
    ...mapState(useOnboardingStore, {
      onboardingStep: 'step',
      onboardingLabel: 'label'
    }),
    onboardingVariant() {
      return ONBOARDING_VARIANTS.basic
    },
    showOnboardingPopover() {
      return this.onboardingStep === 4
    }
  },
  methods: {
    openModal() {
      this.modal.show()
    },
    onboardingOnNext() {
      this.$router.push('/boeken')
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-book-alert {
  background-color: $maize-light;
  padding: 80px 16px;

  &--highlighted {
    z-index: $popover-highlighted-el-zindex;
    position: relative;
  }
}
</style>
